import script from "./ViewEnrollmentDocuments.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewEnrollmentDocuments.vue?vue&type=script&setup=true&lang=js"

import "./ViewEnrollmentDocuments.vue?vue&type=style&index=0&id=5901a42c&lang=scss&scoped=true"
import "./ViewEnrollmentDocuments.vue?vue&type=style&index=1&id=5901a42c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5901a42c"]])

export default __exports__